<template>
  <div>
    <el-table class="list-table-file matlsTable" :data="fileList" border>
      <el-table-column label="序号" type="index" width="60"></el-table-column>

      <el-table-column label="文件名称" min-width="160" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span v-if="onlyName">{{ scope.row.fileName || '-' }}</span>
          <span
            v-else
          >{{ scope.row.fileName || '-' }}</span>
        </template>
      </el-table-column>

      <el-table-column
        label="文件类型"
        min-width="120"
        :show-overflow-tooltip="true"
        v-if="showFileType"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.tableName ? formatfileSuffix(scope.row.tableName) : scope.row.type ? formatfileSuffixPay(scope.row.type) : '-' }}</span>
        </template>
      </el-table-column>

      <!-- <el-table-column label="上传人">
        <template slot-scope="scope">
          <span>{{ scope.row.createBy ? scope.row.createBy : createBy }}</span>
        </template>
      </el-table-column>

      <el-table-column label="上传时间" min-width="160" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime ? parseTime(scope.row.createTime, '{y}-{m}-{d} {h}:{i}') : parseTime(new Date().getTime(), '{y}-{m}-{d} {h}:{i}')}}</span>
        </template>
      </el-table-column> -->

      <el-table-column label="操作" width="140" key="id" fixed="right" class-name="del is-print">
        <template slot-scope="scope">
          <div class="operation">
            <el-button
              type="text"
              :disabled="[ 'mp4','avi','.doc'].includes(scope.row.fileSuffix ? scope.row.fileSuffix.toLowerCase() : '')"
              @click="look(scope.row)"
            >查看</el-button>
            <el-button type="text" @click="downloads(scope.row)">下载</el-button>
            <el-button
              v-if="isEdit && !(disableDelelteFn && disableDelelteFn(scope))"
              v-show="isExamine"
              @click="delFile(scope.row,scope.$index,scope.row)"
              type="text"
              class="delbutton"
            >删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="查看文件" :top="'5vh'" append-to-body :visible.sync="previewFlag" width="80%">
      <div v-if="isImage(previewUrl)" style="text-align: center;width: 100%;height: 100%;overflow: auto;">
        <el-image :src="previewUrl" style="width: auto;" :preview-src-list="[previewUrl]"></el-image>
      </div>
      <vue-office-docx v-else-if="previewUrl" style="height: 680px;" :src="previewUrl" />
    </el-dialog>
    <!-- <el-dialog title="查看文件" append-to-body :visible.sync="previewFlag" width="80%">
      <vue-doc-preview :file="docFileUrl" :type="'doc'"></vue-doc-preview>
    </el-dialog>-->
    <!-- <Mdialog
      title="查看"
      :fullscreen="true"
      :visible.sync="isOpenDialog"
      width="75%"
      :append-to-body="true"
      @closes="cancel"
    >
      <div v-if="['doc','docx'].includes(fileSuffix.toLowerCase())">
        <div v-html="vHtml" style="width: 100%;height: 100%" />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
      </div>
      <span slot="footer">
        <el-button :disabled="loading || fileUploading" class="batch-button" @click="cancel">取 消</el-button>
        <el-button :disabled="fileUploading" :loading="loading" class="line-button" @click="submitFrom">确 定</el-button>
      </span>
    </Mdialog>-->
  </div>
</template>

<script>
// import Mdialog from '@/components/Mdialog'
import VueOfficeDocx from '@vue-office/docx'
import '@vue-office/docx/lib/index.css'
import { isImageLink } from '@/utils/is'
export default {
  name: 'attachment',
  props: {
    onlyName: {
      type: Boolean,
      default: false,
    },
    fileList: {
      type: Array,
    },
    isExamine: {
      type: Boolean,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    showFileType: {
      type: Boolean,
      default: true,
    },
    disableDelelteFn: {
      type: Function,
    },
    //开启api接口删除附件
    enableAPI2Delete: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isImage: isImageLink,
      previewFlag: false,
      previewUrl: '',
      docUr: '',
      vHtml: '', // 查看word
      fileSuffix: '', // 查看word
      isOpenDialog: false,
      createBy: sessionStorage.getItem('nickName'),
      docFileUrl: 'https://example.com/your-doc-file.doc',
    }
  },
  components: { VueOfficeDocx },
  // created() {
  //   let that = this
  //   vm.$on('isOpenDialog', function (data) {
  //     that.isOpenDialog = true
  //     that.vHtml = data
  //   })
  // },
  methods: {
    // getData(fileData){
    //     this.fileData = fileData;
    // },
    // rowStyle({ row, rowIndex }) {
    //   // 如果当前行有添加的className，就添加背景色
    //   // console.log(row, '---------------------colcorrrrrrr')
    //   // if (row.type === 1 || row.type == 2) {
    //   //   return 'greenRowbg'
    //   // } else {
    //   //   return ''
    //   // }
    //   return ''
    // },
    // 查看文件
    look(row) {
      console.log(row, 'row-------------')
      if (this.isImage(row.fileUrl) || ['docx'].includes(row.fileSuffix.toLowerCase())) {
        this.previewUrl = row.fileUrl
        this.previewFlag = true
      } else {
        this.fileShow(row)
      }
    },

    // 下载
    downloads(row) {
      window.location.href = row.fileUrl
    },

    // 删除
    delFile(fileId, index, row) {
      console.log(fileId, index, row, 'aaaaaaaaaa')

      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonClass: 'confirm_button',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$emit('on-del', { index, fileId: fileId.id })
      })
    },

    cancel() {
      this.isOpenDialog = false
    },
    formatFileUrlSuffix(url) {
      return url.substring(url.lastIndexOf('.') + 1)
    },
    // 格式化文件类型
    formatfileSuffix(type) {
      const fileSuffixEnum = {
        // HT: '合同附件',
        // HTGD: '合同归档附件',
        // GZ: '盖章附件',
        // TJH: '调价函附件',
        // TJHGD: '调价函归档附件',
        // BCXY: '补充协议附件',
        // BCXYGD: '补充协议归档附件',
        // CWZFFP: '发票附件',
        // CWZFQT: '其他附件',
        // SKGL: '收款单附件',
      }

      return fileSuffixEnum[type]
    },
    formatfileSuffixPay(type) {
      const fileSuffixEnum = {
        // 1: '发票',
        // 2: '工资表',
        // 3: '收据',
        // 4: '承诺书',
        // 5: '委托书',
        // 6: '其他',
        // 7: '支付回单',
      }

      return fileSuffixEnum[type]
    },
  },
}
</script>

<style lang='less' scoped>
::v-deep {
  .greenRowbg {
    background: #0ebf77 !important;
  }
  .el-table--enable-row-hover .el-table__body tr.greenRowbg:hover > td {
    background-color: #0ebf77 !important;
  }
}

.matlsTable {
  &::before {
    display: none;
  }
  &::after {
    display: none;
  }
  ::v-deep {
    border-radius: 12px;
    border: 2px solid #ebeffa;
    margin-top: 20px;
    .el-table__header {
      background-color: #f8f8f8;
      tr,
      th {
        background-color: #f8f8f8 !important;
        color: #000000;
      }
    }
    td,
    th {
      border-right: none;
      color: #000000;
      // border-bottom: none;
    }
    .el-table__fixed::before,
    .el-table__fixed-right::before {
      display: none;
      width: 0;
    }
    .el-form-item {
      margin-bottom: 20px;
      .el-form-item__content {
        margin-left: 0 !important;
      }
    }

    .el-table__cell {
      padding-bottom: 5px;
    }

    // 禁用 输入框
    .el-input.is-disabled .el-input__inner {
      color: #000000;
      //color: #3C4254;
    }

    // 操作--删除--图标
    .del {
      .cell {
        .svg-icon {
          width: 24px;
          height: 24px;
        }
        // margin-bottom: 10px;
      }
    }
  }
  .el-input__inner {
    //color: ;
  }
  .el-icon-remove-outline {
    color: #fa2256;
  }
}

// 操作
.operation {
  display: flex;
  align-items: center;
  justify-content: left;
  .spantext {
    margin-right: 10px;
    cursor: pointer;
    color: #2f4cdd;
  }
  .look {
    width: 18px;
    height: 12px;
    margin-right: 20px;
    // background: url('../../../../assets/img/view.png') no-repeat left top;
    // &:hover {
    //   background: url('../../../../assets/img/view-active.png') no-repeat left
    //     top;
    // }
  }
  i {
    color: #656d95;
    font-size: 20px;
    margin-right: 20px;
    &:hover {
      color: #2f4cdd;
    }
    //&:nth-child(2){
    //    margin-right: 20px;
    //}
  }
}
</style>
